export const NAME = 'name';

export const TABLE_CONSTANTS_TEST_IDS = {
    TABLE_CELL: 'table_cell_test_id',
    TABLE_ROW: 'table_row_test_id',
    ROLE_COLUMNHEADER: 'columnheader',
};
